(() => {
  if (customElements.get('km-collar-bundle')) return;
  const states = new Map();
  class KMCollarBundle extends HTMLElement {
    async connectedCallback() {
      if (this.initialized || this.disabledByCurrency) return;
      try {
        this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
        this.variants = this.config.variants;
        this.section = this.closest('.shopify-section');
        this.discounts = this.config.discounts;
        this.eligibleProductIds = new Set((this.config.eligibleProductIds || []).map(String));
        if (!this.section || !Number.isInteger(this.config.variantCount) || this.variants.length !== this.config.variantCount || !this.variants.length || !this.eligibleProductIds.has(String(this.config.productId)) || !this.discounts || typeof this.discounts.pair !== 'number' || typeof this.discounts.trio !== 'number' || this.discounts.pair < 0 || this.discounts.trio < this.discounts.pair || this.discounts.trio >= 1 || !this.variants.every(v => Number.isInteger(v.id) && typeof v.color === 'string' && typeof v.size === 'string' && Number.isInteger(v.price) && v.price > 0)) return;
        this.cartEligibleQuantity = 0;
        this.nativePicker = this.section.querySelector('variant-picker[data-product-id="' + this.config.productId + '"]');
        this.nativeForm = this.section.querySelector('product-form-component[data-product-id="' + this.config.productId + '"] form');
        if (!this.nativeForm || !this.nativePicker) return;
        this.labels = this.config.labels;
        this.colors = [...new Set(this.variants.map(v => v.color))];
        this.sizes = [...new Set(this.variants.map(v => v.size))];
        const first = this.variants.find(v => v.available) || this.variants[0];
        this.state = states.get(String(this.config.productId));
        if (!this.state) {
          this.state = { tier: 2, items: Array.from({ length: 3 }, () => ({ color: first.color, size: first.size })), nativeKey: '' };
          states.set(String(this.config.productId), this.state);
        }
        this.error = this.querySelector('[data-error]');
        this.button = this.querySelector('[data-add-bundle]');
        this.bagLink = this.querySelector('[data-bag-link]');
        this.hiddenNative = new Set();
        this.onChangeBound = this.onChange.bind(this);
        this.onNativeBound = e => {
          if (this.contains(e.target)) return;
          if (e.target.closest('variant-picker')) queueMicrotask(() => this.syncNativeSelection());
        };
        this.onAddBound = this.addBundle.bind(this);
        this.onPageShowBound = () => {
          if (!this.initialized || this.busy) return;
          this.refreshCartState().then(() => {
            if (this.isConnected && this.initialized) this.render();
          }).catch(() => this.deactivate());
        };
        this.onCartUpdateBound = event => {
          if (!event.promise || typeof event.promise.then !== 'function') return;
          this.cartUpdatePromise = Promise.resolve(event.promise).catch(() => null);
          this.cartUpdatePromise.then(this.onPageShowBound);
        };
        this.onVisibilityBound = () => {
          if (!document.hidden) this.onPageShowBound();
        };
        this.addEventListener('change', this.onChangeBound);
        this.section.addEventListener('change', this.onNativeBound);
        this.button.addEventListener('click', this.onAddBound);
        window.addEventListener('pageshow', this.onPageShowBound);
        window.addEventListener('focus', this.onPageShowBound);
        document.addEventListener('visibilitychange', this.onVisibilityBound);
        this.initialized = true;
        this.syncNativeSelection();
        this.render();
        await this.refreshCartState();
        if (!this.isConnected || !this.initialized) return;
        this.render();
        this.hideNative();
        this.observer = new MutationObserver(() => {
          if (!this.isConnected || !this.initialized || this.busy) return;
          this.hideNative();
          this.syncNativeSelection();
        });
        this.observer.observe(this.section, { childList: true, subtree: true });
        this.hidden = false;
        import('@shopify/events').then(({ StandardEvents }) => {
          if (!this.isConnected || !this.initialized || typeof StandardEvents?.cartLinesUpdate !== 'string') return;
          this.cartEventName = StandardEvents.cartLinesUpdate;
          document.addEventListener(this.cartEventName, this.onCartUpdateBound);
        }).catch(() => {});
      } catch (error) {
        this.deactivate();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.section?.removeEventListener('change', this.onNativeBound);
      this.removeEventListener('change', this.onChangeBound);
      this.button?.removeEventListener('click', this.onAddBound);
      window.removeEventListener('pageshow', this.onPageShowBound);
      window.removeEventListener('focus', this.onPageShowBound);
      document.removeEventListener('visibilitychange', this.onVisibilityBound);
      if (this.cartEventName) document.removeEventListener(this.cartEventName, this.onCartUpdateBound);
      this.cartEventName = null;
      this.cartRequestId = (this.cartRequestId || 0) + 1;
      this.restoreNative();
      this.initialized = false;
    }
    hideNative() {
      if (!this.initialized) return;
      this.section.querySelectorAll('product-form-component[data-product-id="' + this.config.productId + '"]').forEach(component => {
        const wrapper = component.closest('.buy-buttons-block') || component;
        wrapper.classList.add('ecb-native-hidden');
        this.hiddenNative.add(wrapper);
      });
      this.section.querySelectorAll('sticky-add-to-cart').forEach(node => {
        node.classList.add('ecb-native-hidden');
        this.hiddenNative.add(node);
      });
    }
    restoreNative() {
      this.hiddenNative?.forEach(node => node.classList.remove('ecb-native-hidden'));
      this.hiddenNative?.clear();
    }
    deactivate() {
      this.observer?.disconnect();
      this.section?.removeEventListener('change', this.onNativeBound);
      this.removeEventListener('change', this.onChangeBound);
      this.button?.removeEventListener('click', this.onAddBound);
      window.removeEventListener('pageshow', this.onPageShowBound);
      window.removeEventListener('focus', this.onPageShowBound);
      document.removeEventListener('visibilitychange', this.onVisibilityBound);
      if (this.cartEventName) document.removeEventListener(this.cartEventName, this.onCartUpdateBound);
      this.cartEventName = null;
      this.cartRequestId = (this.cartRequestId || 0) + 1;
      this.initialized = false;
      this.restoreNative();
      this.hidden = true;
    }
    syncNativeSelection() {
      if (!this.initialized || !this.state || this.busy) return;
      const picker = this.section.querySelector('variant-picker[data-product-id="' + this.config.productId + '"]');
      const selected = Array.from(picker?.querySelectorAll('input[data-option-name]:checked') || []);
      const color = selected.find(input => input.dataset.optionName === this.config.colorOptionName)?.value;
      const size = selected.find(input => input.dataset.optionName === this.config.sizeOptionName)?.value;
      if (!color || !size) return;
      const key = color + '/' + size;
      if (this.state.nativeKey === key) return;
      this.state.nativeKey = key;
      if (this.variants.some(v => v.color === color && v.size === size)) {
        this.state.items[0] = { color: color, size: size };
        this.render();
      }
    }
    variantFor(item) {
      return this.variants.find(v => v.color === item.color && v.size === item.size);
    }
    setOptions(select, values, current, available) {
      select.replaceChildren();
      values.forEach(value => {
        const option = document.createElement('option');
        const enabled = available(value);
        option.value = value;
        option.textContent = enabled ? value : value + ' — ' + this.labels.unavailable_label;
        option.disabled = !enabled;
        option.selected = value === current;
        select.append(option);
      });
    }
    discountForQuantity(quantity) {
      return quantity >= 3 ? this.discounts.trio : quantity >= 2 ? this.discounts.pair : 0;
    }
    eligibleQuantity(bag) {
      return bag.items.filter(item => this.eligibleProductIds.has(String(item.product_id))).reduce((sum, item) => sum + item.quantity, 0);
    }
    quote(tier) {
      const variants = this.state.items.slice(0, tier).map(item => this.variantFor(item));
      if (variants.some(variant => !variant)) return null;
      const discount = this.discountForQuantity(this.cartEligibleQuantity + tier);
      const subtotal = variants.reduce((sum, variant) => sum + variant.price, 0);
      const compareAt = variants.reduce((sum, variant) => sum + (Number(variant.compareAt) > variant.price ? Number(variant.compareAt) : variant.price), 0);
      const savings = variants.reduce((sum, variant) => sum + Math.floor(variant.price * discount), 0);
      const total = subtotal - savings;
      return { subtotal, total, compareAt, savings, unit: total / tier, sameUnitPrice: variants.every(variant => variant.price === variants[0].price) };
    }
    async refreshCartState() {
      const requestId = this.cartRequestId = (this.cartRequestId || 0) + 1;
      const bagController = new AbortController();
      const bagTimeout = setTimeout(() => bagController.abort(), 12000);
      let bag;
      try {
        const response = await fetch(this.rootPath() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store', signal: bagController.signal });
        if (!response.ok) throw new Error(this.labels.request_error);
        bag = await response.json();
      } finally {
        clearTimeout(bagTimeout);
      }
      if (requestId !== this.cartRequestId) return null;
      if (bag.currency !== this.config.currency) {
        this.disabledByCurrency = true;
        this.deactivate();
        return null;
      }
      if (!Array.isArray(bag.items)) throw new Error(this.labels.request_error);
      this.cartEligibleQuantity = this.eligibleQuantity(bag);
      return bag;
    }
    render() {
      if (!this.initialized || !this.state) return;
      this.querySelectorAll('[data-tier]').forEach(card => {
        const active = Number(card.dataset.tier) === this.state.tier;
        card.classList.toggle('is-selected', active);
        const radio = card.querySelector('[data-tier-input]');
        radio.checked = active;
        radio.disabled = !!this.busy;
        const panel = card.querySelector('.ecb-selectors');
        panel.hidden = !active;
        const quote = this.quote(Number(card.dataset.tier));
        if (quote) {
          card.querySelector('[data-tier-price]').textContent = this.money(quote.total);
          const compare = card.querySelector('[data-tier-compare]');
          compare.textContent = this.money(quote.compareAt);
          compare.hidden = quote.compareAt <= quote.total;
          card.querySelector('[data-tier-subtitle]').textContent = Number(card.dataset.tier) === 1 && quote.savings === 0 ? this.labels.standard_label : (quote.sameUnitPrice ? this.labels.only_label : this.labels.average_label) + ' ' + this.money(quote.unit) + ' ' + this.labels.each_label;
        }
        card.querySelectorAll('[data-row-index]').forEach(row => {
          const index = Number(row.dataset.rowIndex);
          const item = this.state.items[index];
          const colorSelect = row.querySelector('[data-color]');
          const sizeSelect = row.querySelector('[data-size]');
          this.setOptions(colorSelect, this.colors, item.color, color => this.variants.some(v => v.color === color && v.available));
          this.setOptions(sizeSelect, this.sizes, item.size, size => this.variants.some(v => v.color === item.color && v.size === size && v.available));
          colorSelect.disabled = !active || !!this.busy;
          sizeSelect.disabled = !active || !!this.busy;
          const variant = this.variantFor(item);
          const image = row.querySelector('[data-row-image]');
          if (variant?.image) {
            if (image.getAttribute('src') !== variant.image) image.src = variant.image;
            image.alt = this.config.productTitle + ' — ' + item.color;
          }
        });
      });
      const quote = this.quote(this.state.tier);
      const savings = this.querySelector('[data-savings]');
      savings.hidden = !quote || quote.savings === 0;
      savings.textContent = this.labels.saving_prefix + ' ' + this.money(quote?.savings || 0) + ' ' + this.labels.saving_suffix;
      const valid = this.state.items.slice(0, this.state.tier).every(item => this.variantFor(item)?.available);
      this.button.disabled = !!this.busy || !valid;
      this.button.textContent = this.busy ? this.labels.adding_label : this.labels.add_label;
      this.button.setAttribute('aria-busy', String(!!this.busy));
    }
    onChange(event) {
      if (!this.initialized || this.busy) return;
      const tier = event.target.closest('[data-tier-input]');
      if (tier) {
        this.state.tier = Number(tier.value);
        this.clearError();
        this.render();
        return;
      }
      const row = event.target.closest('[data-row-index]');
      if (!row) return;
      const index = Number(row.dataset.rowIndex);
      const item = this.state.items[index];
      if (event.target.matches('[data-color]')) {
        item.color = event.target.value;
        const matching = this.variantFor(item);
        if (!matching?.available) {
          const next = this.variants.find(v => v.color === item.color && v.available);
          if (next) item.size = next.size;
        }
      } else if (event.target.matches('[data-size]')) item.size = event.target.value;
      this.clearError();
      this.render();
    }
    clearError() {
      this.error.hidden = true;
      this.error.textContent = '';
      this.bagLink.hidden = true;
    }
    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
      this.bagLink.hidden = false;
      this.error.focus({ preventScroll: true });
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.config.currency }).format(cents / 100);
    }
    rootPath() {
      const path = window.Shopify?.routes?.root || '/';
      return path.endsWith('/') ? path : path + '/';
    }
    async addBundle() {
      if (!this.initialized || this.busy) return;
      this.clearError();
      const grouped = new Map();
      for (const item of this.state.items.slice(0, this.state.tier)) {
        const variant = this.variantFor(item);
        if (!variant?.available) {
          this.showError(this.labels.selection_error);
          return;
        }
        const line = grouped.get(variant.id) || { variant: variant, quantity: 0 };
        line.quantity += 1;
        grouped.set(variant.id, line);
      }
      const quotedTotal = this.quote(this.state.tier)?.total;
      this.busy = true;
      this.render();
      try {
        const root = this.rootPath();
        if (this.cartUpdatePromise) {
          let updateTimeout;
          try {
            await Promise.race([this.cartUpdatePromise, new Promise((resolve, reject) => {
              updateTimeout = setTimeout(() => reject(new Error(this.labels.request_error)), 12000);
            })]);
          } finally {
            clearTimeout(updateTimeout);
          }
        }
        const bag = await this.refreshCartState();
        if (!bag || !this.isConnected || !this.initialized) return;
        this.render();
        if (this.quote(this.state.tier)?.total !== quotedTotal) {
          this.showError(this.labels.price_changed_error);
          return;
        }
        for (const [id, line] of grouped) {
          const existing = bag.items.filter(item => Number(item.variant_id) === Number(id)).reduce((sum, item) => sum + item.quantity, 0);
          if (line.variant.management && line.variant.policy !== 'continue' && existing + line.quantity > line.variant.inventory) throw new Error(this.labels.stock_error);
        }
        const items = [...grouped].map(([id, line]) => ({ id: Number(id), quantity: line.quantity }));
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        let response;
        let result;
        try {
          response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }), signal: controller.signal });
          result = await response.json();
        } finally {
          clearTimeout(timeout);
        }
        if (!response.ok) {
          const failure = new Error(typeof result.description === 'string' ? result.description : this.labels.request_error);
          failure.customerMessage = true;
          throw failure;
        }
        window.location.assign(root + 'cart');
      } catch (error) {
        const message = error?.customerMessage || error?.message === this.labels.stock_error ? error.message : this.labels.request_error;
        this.showError(message);
      } finally {
        this.busy = false;
        if (this.isConnected && this.initialized) this.render();
      }
    }
  }
  customElements.define('km-collar-bundle', KMCollarBundle);
})();
